import styled from 'styled-components'

const FieldLabel = styled.label`
  font-size: 16px;
  color: #a4a9b7;
  user-select: none;
  padding-bottom: 8px;
`

export default FieldLabel
